/*
 * Application Insights JavaScript SDK - Click Analytics, 2.8.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_EXTENSION_CONFIG = "extensionConfig"; // Count: 5
export var _DYN_PAGE_ACTION_PAGE_TAG0 = "pageActionPageTags"; // Count: 2
export var _DYN_TRACK_PAGE_ACTION = "trackPageAction"; // Count: 4
export var _DYN_LENGTH = "length"; // Count: 5
export var _DYN_TAG_NAME = "tagName"; // Count: 4
export var _DYN_TO_UPPER_CASE = "toUpperCase"; // Count: 4
export var _DYN_PATHNAME = "pathname"; // Count: 3
export var _DYN_ADD_EVENT_LISTENER = "addEventListener"; // Count: 2
export var _DYN_PAGE_NAME = "pageName"; // Count: 8
export var _DYN_CORE_DATA = "coreData"; // Count: 4
export var _DYN_REQUEST_URI = "requestUri"; // Count: 3
export var _DYN_GET_ATTRIBUTE = "getAttribute"; // Count: 6
export var _DYN_PARENT_NODE = "parentNode"; // Count: 3
export var _DYN_CUSTOM_DATA_PREFIX = "customDataPrefix"; // Count: 6
export var _DYN_INDEX_OF = "indexOf"; // Count: 8
export var _DYN_DATA_TAGS = "dataTags"; // Count: 7
export var _DYN_USE_DEFAULT_CONTENT_1 = "useDefaultContentNameOrId"; // Count: 5
export var _DYN_AI_BLOB_ATTRIBUTE_TA2 = "aiBlobAttributeTag"; // Count: 2
export var _DYN_CAPTURE_ALL_META_DAT3 = "captureAllMetaDataContent"; // Count: 3
export var _DYN_BEHAVIOR_VALIDATOR = "behaviorValidator"; // Count: 2
export var _DYN_NAME = "name"; // Count: 8
export var _DYN_DATA = "data"; // Count: 15
export var _DYN_PAGE_TYPE = "pageType"; // Count: 6
export var _DYN_PROPERTIES = "properties"; // Count: 4
export var _DYN_ACTION_TYPE = "actionType"; // Count: 9
export var _DYN_BEHAVIOR = "behavior"; // Count: 7
export var _DYN_CLICK_COORDINATES = "clickCoordinates"; // Count: 2
export var _DYN_CONTENT = "content"; // Count: 4
export var _DYN_REF_URI = "refUri"; // Count: 4
export var _DYN_PARENT_ID = "parentId"; // Count: 3
export var _DYN_CAPTURE_PAGE_ACTION = "capturePageAction"; // Count: 2
export var _DYN_SET_COMMON_PROPERTIE4 = "setCommonProperties"; // Count: 2
export var _DYN_GET_ELEMENT_CONTENT = "getElementContent"; // Count: 2
export var _DYN__GET_VALID_BEHAVIOR = "_getValidBehavior"; // Count: 3
export var _DYN_CONTENT_NAME = "contentName"; // Count: 12
export var _DYN__TRACE_LOGGER = "_traceLogger"; // Count: 3
export var _DYN_CLICK_COORDINATE_X = "clickCoordinateX"; // Count: 3
export var _DYN_CLICK_COORDINATE_Y = "clickCoordinateY"; // Count: 3
export var _DYN__CONFIG = "_config"; // Count: 9
export var _DYN_PARENT_DATA_TAG = "parentDataTag"; // Count: 3
export var _DYN__PAGE_TAGS = "_pageTags"; // Count: 6
export var _DYN__PAGE_TAGS_CALLBACK = "_pageTagsCallback"; // Count: 3
export var _DYN__META_TAGS = "_metaTags"; // Count: 6
export var _DYN_SET_BASIC_PROPERTIES = "setBasicProperties"; // Count: 2
export var _DYN__PAGE_TYPE_META_TAG = "_pageTypeMetaTag"; // Count: 3
export var _DYN__BEHAVIOR_META_TAG = "_behaviorMetaTag"; // Count: 3
export var _DYN_PARENT_ELEMENT = "parentElement"; // Count: 3
export var _DYN_ATTRIBUTES = "attributes"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map